import { is } from 'immutable';
import { isLegacySenderMap } from './isLegacySenderMap';
const SENDER_FIELDS = {
  avatar: true,
  email: true,
  firstName: true,
  id: true,
  isActive: true,
  isAuthorized: true,
  lastName: true,
  senderType: true
};
const SENDER_FIELD_NAMES = Object.keys(SENDER_FIELDS);
function areSendersShallowEqual(a, b) {
  return SENDER_FIELD_NAMES.every(fieldName => a[fieldName] === b[fieldName]);
}
export function areSenderMapsEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return !a && !b;
  }
  const isALegacy = isLegacySenderMap(a);
  const isBLegacy = isLegacySenderMap(b);
  if (isALegacy && isBLegacy) {
    return is(a, b);
  }
  if (isALegacy || isBLegacy) {
    return false;
  }
  if (a.size !== b.size) {
    return false;
  }
  for (const [key, senderA] of a) {
    const senderB = b.get(key);
    if (senderB === undefined || !areSendersShallowEqual(senderA, senderB)) {
      return false;
    }
  }
  return true;
}